import { __assign } from 'tslib';
import React from 'react';
import { CaretRightIcon } from '@panwds/icons';

function RowExpansionToggle(_a) {
    var row = _a.row;
    return (React.createElement("button", __assign({ "aria-label": row.isExpanded ? "Collapse row" : "Expand row" }, row.getToggleRowExpandedProps({
        className: "tw-box-border tw-flex tw-items-center tw-border-none tw-p-0 tw-m-0 focus:tw-outline-none focus:tw-ring tw-bg-transparent tw-rounded tw-mr-1"
    }), { type: "button" }),
        React.createElement(CaretRightIcon, { size: "xxs", className: "tw-transition-transform tw-duration-200 tw-transform ".concat(row.isExpanded ? "tw-rotate-90" : "tw-rotate-0") })));
}

export { RowExpansionToggle };
//# sourceMappingURL=RowExpansionToggle.esm.js.map
